import { Provider } from '@angular/core';
import { FGTS_SIUMP_REPOSITORY } from './repositories/fgts-siump.repository';
import { FgtsSiumpService } from './services/fgts-siump.service';

export const FGTS_SIUMP_PROVIDERS: Provider[] = [
  {
    provide: FGTS_SIUMP_REPOSITORY,
    useClass: FgtsSiumpService
  }
];
